module.exports = __webpack_public_path__ + "static/img/05.7d2fa0a8.png";